import { generateHeaderPdf, getHeaderStaticPdf, mergedPdfHeader } from "./StaticPdfUtils";

// PDF Path
const PDF = "/static/pdf/printList/fm_rad_004.pdf";
// const FONT = "/static/fonts/THSarabunNew-Bold.ttf"; //* กรณีแก้ Font

const FormPregnantScanTH = async (props: any) => {
  try {
    const pdfPath = props.items?.headerInfo?.file_path ?? PDF;
    const existingPdfBytes = await fetch(pdfPath).then((res) => res.arrayBuffer());
    const pdfBytes = new Uint8Array(existingPdfBytes);

    const headerDef = await getHeaderStaticPdf({
      formName: `${props.items?.headerInfo?.name}`,
      patientInfo: props.items,
      detail: props.detail,
      headerMargins: [8, 8, 8, 0],
      freeLine: 1,
    }, "mini");

    const headerPdfBytes = await generateHeaderPdf(headerDef);

    const mergedPdfBytes = await mergedPdfHeader(pdfBytes, headerPdfBytes);

    const blob = new Blob([mergedPdfBytes as BlobPart], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    return {
      uint8Array: mergedPdfBytes,
      blobUrl,
      blobRaw: blob,
      base64String: Buffer.from(mergedPdfBytes).toString("base64"),
    };
  } catch (error) {
    console.error("Error modifying PDF: ", error);
    return {};
  }
};

export default FormPregnantScanTH;
